import { render, staticRenderFns } from "./index.vue?vue&type=template&id=bc0fca0a"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/tentacles/servers/appservers/video-admin-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bc0fca0a')) {
      api.createRecord('bc0fca0a', component.options)
    } else {
      api.reload('bc0fca0a', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=bc0fca0a", function () {
      api.rerender('bc0fca0a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/HeaderPassword/index.vue"
export default component.exports